
// import { MessageThread } from '../../Models/MessageCenter/MessageThread'
import Avatar from 'react-avatar';
import { useState } from 'react';
import { MessageThread } from '../../../models/QuestionarieMCModal';
export interface MessageChatProps {
    messageThread?: MessageThread | null
}
function MessageChatWindowHeaderFC(props: MessageChatProps) {
  const [readMore, setReadMore] = useState(false);

    return (
        <div className='modal-message-header'>
            <div className='ms-1 me-auto'>
                <Avatar name={(props?.messageThread?.clientName || "").trim() || 
                ((props?.messageThread?.userDisplayFirstName || "")
                .trim()+ " "+(props?.messageThread?.userDisplayLastName || "").trim())} size="30" round={true} />
            </div>
            <div className='ms-2 me-auto message-header'>
                <div className='fw-bold'>
                    <span>{(props?.messageThread?.clientName || "").trim()  ||
                     ((props?.messageThread?.userDisplayFirstName || "")
                     .trim()+ " "+(props?.messageThread?.userDisplayLastName || "").trim()) }</span>
                    <span>&nbsp;&nbsp;</span>
                    <span>{props?.messageThread?.clientCompany}</span>
                </div>
                <div 
                  className={`subject ${readMore ? "expand" : "contract"}`}  
                  onClick={() => setReadMore(prev => !prev)}
                >
                    <span>Subject: </span><span className='fw-bold subject'>{props?.messageThread?.subject}</span>
                    <span>&nbsp;&nbsp;</span>
                    <span className='message-text'>{props?.messageThread?.message}</span>
                </div>
            </div>
        </div>
    )
}

export default MessageChatWindowHeaderFC